import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { PhxIconModule } from '../../icon/icon.module';
import { PhxTooltipModule } from '../../tooltip/phx-tooltip.module';
import { PhxTagModule } from '../../tag/phx-tag.module';
import { PhxButtonModule } from '../../button/phx-button.module';
import { PhxDropdownModule } from '../../dropdown/phx-dropdown.module';
import { PhxMenuModule } from '../../menu/menu.module';
import { PhxDividerModule } from '../../divider/phx-divider.module';
import { PhxTextModule } from '../../text/phx-text.module';
import { PhxTranslationsRootModule } from '../../../translation/transloco-root.module';

import { PhxTableCellStringComponent } from './cell-string/phx-table-cell-string.component';
import { PhxTableCellTagComponent } from './cell-tag/phx-table-cell-tag.component';
import { PhxTableCellMediaComponent } from './cell-media/phx-table-cell-media.component';
import { PhxTableCellActionComponent } from './cell-action/phx-table-cell-action.component';
import { PhxTableCellCustomComponent } from './cell-custom/phx-table-cell-custom.component';
import { PhxTableCellIconComponent } from './cell-icon/phx-table-cell-icon.component';

@NgModule({
  declarations: [
    PhxTableCellStringComponent,
    PhxTableCellTagComponent,
    PhxTableCellMediaComponent,
    PhxTableCellActionComponent,
    PhxTableCellCustomComponent,
    PhxTableCellIconComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    PhxIconModule,
    PhxTooltipModule,
    PhxTagModule,
    PhxButtonModule,
    PhxDropdownModule,
    PhxMenuModule,
    PhxDividerModule,
    PhxTextModule,
    PhxTranslationsRootModule,
  ],
  exports: [
    PhxTextModule,
    PhxTableCellStringComponent,
    PhxTableCellTagComponent,
    PhxTableCellMediaComponent,
    PhxTableCellActionComponent,
    PhxTableCellCustomComponent,
    PhxTableCellIconComponent,
  ],
})
export class PhxTableCellsModule {}
